<template>
    <div>
        <Header title="评价" type="0" :route="'/bk/xspjItem?params=' + JSON.stringify(this.params)"></Header>
        <!-- <NOdata title="功能暂未开放~"></NOdata>    -->
        <div class="eva-detail">
            <p class="eva-num">
                <span>{{ evaluateIndex + 1 }}</span>
                /{{ this.total }}
            </p>
            <!-- 选项评价 -->
            <div v-if="evaluateIndex < optionList.length">
                <p class="eva-topic">
                    {{ this.curList.pjzbmc }}
                </p>
                <div class="eva-rate">
                    <ul>
                        <li @click="choose($event, item.pj0601id, index)" v-for="(item, index) in curList.lstpj0601" :key="index" :data-ids="item.pj0601id" :data-va="valueList[evaluateIndex]" :class="valueList[evaluateIndex] == item.pj0601id ? 'checked' : ''" v-html="String.fromCharCode(index + 65) + '.' + item.mc"></li>
                    </ul>
                </div>
            </div>
            <div v-else>
                <div>
                    <p class="eva-topic">
                        {{ areaList[evaluateIndex - optionList.length] ? areaList[evaluateIndex - optionList.length].jymc : '' }}
                    </p>
                    <div class="eva-rate">
                        <textarea name placeholder="请点击填写" v-model="evaText[evaluateIndex - optionList.length]"></textarea>
                        <span>{{ calcNum() }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="eva-buttons">
            <button class="pre-topic" v-if="evaluateIndex != 0" @click="preTopic()">
                上一题
            </button>
            <button class="eva-btn" @click="nextTopic()" v-text="evaluateIndex + 1 == total ? '保存' : '下一题'" :style="evaluateIndex == 0 ? 'width:100%' : ''"></button>
        </div>
    </div>
</template>

<script>
import { Api } from '@/utils/axios';
export default {
    data() {
        return {
            evaluateIndex: 0,
            optionList: [],
            areaList: [],
            curList: {},
            list: '',
            params: '',
            total: 0,
            isCheck: null,
            evaText: [],
            valueList: [],
            pj03idList: [],
            lstpj0601List: [],
            xztList: [],
            schoolCode: ''
        };
    },
    created() {
        this.schoolCode = sessionStorage.getItem('schoolCode');
        this.params = this.$route.query.params;
        this.list = this.$route.query.list;
        this.getList();
    },
    methods: {
        async save() {
            const res = await Api.xspj_save({
                pj0502id: this.$route.query.pj0502id,
                pj05id: this.$route.query.pj05id,
                xnxq01id: this.$route.query.xnxq01id,
                issubmit: this.$route.query.issubmit,
                pj06xh: this.valueList.join(','),
                pj01id: this.$route.query.pj01id,
                jx02id: this.$route.query.jx02id,
                jx0404id: this.$route.query.jx0404id,
                jynrs: this.evaText.join('#')
            });
            if (res.code == '1') {
                this.$toast.success('保存成功');
                setTimeout(() => {
                    this.$router.replace('/bk/xspj');
                }, 1500);
            } else {
                return;
            }
        },
        calcNum() {
            this.maxNum = 140 - this.evaText.length;
            return this.maxNum;
        },
        choose(e, bh, index) {
            // var index = $("ul li").index(e.currentTarget);
            // $(e.currentTarget).addClass("checked");
            // $(e.currentTarget)
            //   .siblings()
            //   .removeClass("checked");
            this.optionList[this.evaluateIndex].lstpj0601[index].ischecked = '1';
            this.$set(this.valueList, this.evaluateIndex, bh);
        },
        preTopic() {
            this.evaluateIndex = Number(this.evaluateIndex) - 1;
            this.curList = this.optionList[this.evaluateIndex];
        },
        nextTopic() {
            if (Number(this.evaluateIndex) + 1 == this.total) {
                this.save();
                return;
            } else {
                if (Number(this.evaluateIndex) + 1 <= this.optionList.length) {
                    if ($('ul li').hasClass('checked') == false) {
                        this.$toast.fail('请选择选项！');
                        return;
                    }
                    this.evaluateIndex = Number(this.evaluateIndex) + 1;
                    this.curList = this.optionList[this.evaluateIndex];
                    // this.isChecked()
                    // $('ul li').removeClass('checked');
                } else {
                    if (this.evaText[this.evaluateIndex - this.optionList.length] == undefined) {
                        this.evaText[this.evaluateIndex - this.optionList.length] = '';
                    }
                    this.evaluateIndex = Number(this.evaluateIndex) + 1;
                }
            }
        },
        async getList() {
            const res = await Api.xspj_edit({
                pj0502id: this.$route.query.pj0502id,
                jx02id: this.$route.query.jx02id,
                xnxq01id: this.$route.query.xnxq01id,
                jx0404id: this.$route.query.jx0404id,
                zpf: this.$route.query.zpf,
                pj01id: this.$route.query.pj01id
            });
            this.optionList = res.lstPj06;
            this.areaList = res.lstPj03;
            this.curList = this.optionList[this.evaluateIndex];
            this.total = this.optionList.length + this.areaList.length;
            this.xztList = res.xzt;
            if ([10008].includes(+this.schoolCode)) {
                this.valueList = res.xzt.map((item) => item.pj0601id);
            }
        }
    }
};
</script>
<style lang="less">
.eva-detail {
    padding: 0 20px 50px;

    .eva-num {
        color: @attendance-background-color-2;
        font-size: 18px;
    }
    .eva-num span {
        color: @attendance-background-color-1;
        font-size: 48px;
        font-weight: 600;
    }

    .eva-topic {
        color: @attendance-color-2;
        font-size: 18px;
        font-weight: 600;
        line-height: 25px;
    }
    .eva-rate {
        margin-top: 20px;
    }
    .eva-rate ul li {
        padding: 20px;
        font-weight: 600;
        border-radius: 5px;
        margin-bottom: 20px;
        background-color: @attendance-background-color-10;
        color: @attendance-color-1;
    }
    .eva-rate ul .checked {
        padding: 20px;
        font-weight: 600;
        border-radius: 5px;
        margin-bottom: 20px;
        background-color: @attendance-background-color-12;
        color: @attendance-color-3;
    }

    .eva-rate textarea {
        width: 100%;
        padding: 20px;
        background-color: @attendance-background-color-6;
        border-radius: 3px;
        box-sizing: border-box;
        color: @attendance-color-1;
        height: 350px;
    }
    .eva-rate textarea::placeholder {
        color: @attendance-color-2;
    }
    .eva-rate {
        position: relative;
    }
    .eva-rate span {
        color: @attendance-color-2;
        position: absolute;
        bottom: 20px;
        right: 20px;
    }
}

.eva-buttons {
    position: fixed;
    bottom: 0px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0 20px;
    box-sizing: border-box;
    padding-bottom: 20px;
    background-color: @attendance-color-3;
}
.eva-buttons button {
    border-radius: 3px;
    padding: 11px 0;
    width: 45%;
}
.eva-buttons .eva-btn {
    background-color: @attendance-background-color-1;
    color: @attendance-color-3;
}
.eva-buttons .pre-topic {
    background-color: @attendance-background-color-6;
    color: @attendance-background-color-1;
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/bkEvaluate/pj.vue